import React from 'react';

interface ModalProps {
    isOpen: boolean;
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    onSave: () => void;
    saveLabel?: string;
    variant?: 'primary' | 'danger';
}

const Modal: React.FC<ModalProps> = ({
    isOpen,
    title,
    onClose,
    children,
    onSave,
    saveLabel = 'Save',
    variant = 'primary',
}) => {
    if (!isOpen) return null;

    const buttonStyles =
        variant === 'danger'
            ? 'bg-red-600 hover:bg-red-700 active:bg-red-800 shadow-red-500/20'
            : 'bg-blue-600 hover:bg-blue-700 active:bg-blue-800 shadow-blue-500/20';

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity">
            <div className="bg-white dark:bg-slate-900 rounded-xl shadow-2xl w-full max-w-md border border-gray-200 dark:border-slate-700 overflow-hidden transform transition-all scale-100">
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 dark:border-slate-800">
                    <h3 className="text-lg font-bold text-slate-800 dark:text-white">{title}</h3>
                    <button
                        title="Close"
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
                    >
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto custom-scrollbar">{children}</div>

                <div className="px-6 py-4 bg-gray-50 dark:bg-slate-800/50 flex justify-end gap-3 border-t border-gray-100 dark:border-slate-800">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-slate-300 hover:bg-gray-200 dark:hover:bg-slate-700 rounded-lg transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onSave}
                        className={`px-4 py-2 text-sm font-medium text-white rounded-lg shadow-md transition-all ${buttonStyles}`}
                    >
                        {saveLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
